import { FlightSubBookingResponse } from '@shared/models/flight-sub-booking-response.model';
import * as fromActions from '../actions/travel-flight-sub-booking.actions';

export interface FlightSubBookingState {
  subBooking: FlightSubBookingResponse;
  error: any;
  travellerPatch: {
    loading: boolean;
    loaded: boolean;
    error: any;
  };
  inProgress: boolean;
}

export const initialState: FlightSubBookingState = {
  subBooking: {
    url: '',
    booking_token: '',
    id: null,
    inbound_flight_terms: [],
    outbound_flight_terms: [],
    price_breakdown: {
      booking_fees: {
        amount: null,
        currency_code: '',
      },
      price_difference: {
        amount: null,
        currency_code: '',
      },
      price_per_adult: {
        amount: null,
        currency_code: '',
      },
      price_per_child: {
        amount: null,
        currency_code: '',
      },
      price_per_infant: {
        amount: null,
        currency_code: '',
      },
      tax_per_adult: {
        amount: null,
        currency_code: '',
      },
      tax_per_child: {
        amount: null,
        currency_code: '',
      },
      tax_per_infant: {
        amount: null,
        currency_code: '',
      },
      total_local_price: {
        amount: null,
        currency_code: '',
      },
      total_price: {
        amount: null,
        currency_code: '',
      },
      total_taxes: {
        amount: null,
        currency_code: '',
      },
      merchant_fees: {
        amount: null,
        currency_code: '',
      },
    },
    terms: {
      links: [],
      popups: [],
      text: [],
    },
    included_baggage_allowance: 0,
    travellers: [],
    travellers_names: [],
    travellers_documents_requirements: [],
    is_document_check_required: false,
  },
  error: null,
  travellerPatch: {
    loading: false,
    loaded: false,
    error: null,
  },
  inProgress: false,
};

export function reducer(
  state = initialState,
  action: fromActions.TravelFlightSubBookingActions
): FlightSubBookingState {
  switch (action.type) {
    case fromActions.CREATE_FLIGHT_SUB_BOOKING:
      return {
        ...initialState,
        inProgress: true,
      };
    case fromActions.CLEAR_FLIGHT_SUB_BOOKING:
      return initialState;
    case fromActions.VIEW_FLIGHT_SUB_BOOKING_SUCCESS:
    case fromActions.CREATE_FLIGHT_SUB_BOOKING_SUCCESS:
      return {
        ...state,
        subBooking: action.payload,
        error: null,
        inProgress: false,
      };

    case fromActions.CREATE_FLIGHT_SUB_BOOKING_FAILURE:
      return {
        ...state,
        error: action.payload,
        inProgress: false,
      };
    case fromActions.PATCH_FLIGHT_SUB_BOOKING_TRAVELLERS:
      return {
        ...state,
        travellerPatch: {
          loading: true,
          loaded: false,
          error: null,
        },
      };
    case fromActions.PATCH_FLIGHT_SUB_BOOKING_TRAVELLERS_SUCCESS:
      return {
        ...state,
        subBooking: {
          ...state.subBooking,
          travellers_names: action.payload.travellers_names,
          travellers_documents_requirements: action.payload.travellers_documents_requirements,
        },
        travellerPatch: {
          loading: false,
          loaded: true,
          error: null,
        },
      };
    case fromActions.PATCH_FLIGHT_SUB_BOOKING_TRAVELLERS_FAILURE:
      return {
        ...state,
        travellerPatch: {
          loading: false,
          loaded: false,
          error: action.payload,
        },
      };
    case fromActions.CLEAR_FLIGHT_TRAVELLER_PATCH:
      return {
        ...state,
        travellerPatch: {
          loading: false,
          loaded: false,
          error: null,
        },
      };
    default:
      return state;
  }
}
